import { render, staticRenderFns } from "./addGroup.vue?vue&type=template&id=0007ec28&lang=pug"
import script from "./addGroup.vue?vue&type=script&lang=js"
export * from "./addGroup.vue?vue&type=script&lang=js"
import style0 from "./addGroup.vue?vue&type=style&index=0&id=0007ec28&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports